import {AppForm} from '../../../../../../common/forms/app.form';
import {FormControl, Validators} from '@angular/forms';
import {Injectable} from '@angular/core';

@Injectable()
export class ParcelItemForm extends AppForm {

  constructor() {
    super({
      precinct: new FormControl('', {nonNullable: true, validators: [Validators.required, Validators.maxLength(255)]}),
      registrationNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    });
  }

  public get precinct(): FormControl | null {
    return this.get('precinct') as FormControl | null;
  }

  public get registrationNumber(): FormControl | null {
    return this.get('registrationNumber') as FormControl | null;
  }
}
